export const getPhoneVerificationDescription = (
  labels = {},
  recipientMask,
  { deliveryType = 'sms', voiceCall = false } = {},
) => {
  const recipient = recipientMask || '...'

  const isResolvedLabel = value => value && !value.includes('{labels.')

  if (deliveryType === 'email') {
    const description = isResolvedLabel(labels.codeSendByEmailTo || labels.CODE_SEND_BY_EMAIL_TO)
      ? labels.codeSendByEmailTo || labels.CODE_SEND_BY_EMAIL_TO
      : 'Код подтверждения отправлен на почту'

    return `${description} ${recipient}`.trim()
  }

  if (voiceCall || deliveryType === 'voice-call') {
    const description = isResolvedLabel(
      labels.codeSendByVoiceTo || labels.PROFILE_CODE_SEND_BY_VOICE_TO,
    )
      ? labels.codeSendByVoiceTo || labels.PROFILE_CODE_SEND_BY_VOICE_TO
      : 'поступит звонок. Введите последние 4 цифры номера.'

    return `На номер ${recipient} ${description}`
  }

  if (isResolvedLabel(labels.codeSendBySMSTo || labels.CODE_SEND_BY_SMS_TO)) {
    return `${labels.codeSendBySMSTo || labels.CODE_SEND_BY_SMS_TO} ${recipient}`.trim()
  }

  return `Код подтверждения отправлен на номер ${recipient}`
}
